module.exports = __webpack_public_path__ + "img/quest_icon_0051_animal.c020aed4.png";